import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export default function ErrorPage() {
    const error = useRouteError();
    console.error(error);

    if (isRouteErrorResponse(error)) {
        return <div>
            <p>Something happened</p>
            <p>{error.status}</p>
            <p>{error.statusText}</p>
        </div>;
    } else {
        return <div>
            <p>Error occurred</p>
            <p>{String(error)}</p>
        </div>;
    }

}